import React from "react";

import { useSelector } from "react-redux";
import { checkAccessFn } from "../../../../../../utils/checkAccess";
import { useNavigate } from "react-router-dom";

export const capitalize = (str) =>
  str.replace(/^(.)|\s+(.)/g, (c) => c.toUpperCase());

export default function TabsComponent({
  currentSection,
  setCurrentSection,
  navButtons,
}) {
  const navigate = useNavigate();
  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  return (
    <div className="w-full bg-white border-b border-slate-200 px-4 flex flex-wrap gap-1 p-2">
      {navButtons.map((btn) => {
        const hasAccess = btn.checkAccessMain && btn.checkAccessSub
          ? checkAccess(btn.checkAccessMain, btn.checkAccessSub)
          : true;
        if (!hasAccess) return null;
        const isActive = currentSection === btn.name;
        return (
          <button
            key={btn.id}
            disabled={btn?.disabled}
            onClick={() => {
              setCurrentSection(btn.name);
              if (btn.url !== "") navigate(btn.url);
            }}
            className={`px-4 py-2 rounded-t-md font-medium uppercase transition-colors ${
              isActive ? "bg-red text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
            } ${btn?.disabled ? "opacity-40 cursor-not-allowed" : ""}`}
          >
            {capitalize(btn?.name?.split("-").join(" "))}
          </button>
        );
      })}
    </div>
  );
}
